import React from "react";
import { Toolbar, Box } from "@mui/material";
import SideMenuBar from "./SideMenuBar";
import { AppBarHeader } from "./header/AppBarHeader";
import { Outlet } from "react-router-dom"; // Import Outlet

function MainDash() {
  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen((current) => !current);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBarHeader open={open} handleDrawerOpen={handleDrawerOpen} />
      <SideMenuBar open={open} setOpen={setOpen} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          height: "100vh",
          overflowY: "auto",
          bgcolor: "#f7f9fc",
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 64, md: 72 } }} />
        <Box sx={{ px: { xs: 1, sm: 2, md: 3 }, py: { xs: 1.5, md: 2.5 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default MainDash;
